import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faNewspaper, faClock, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import indIcon from "../../assets/Ind.png";
import bikeImage from "../../assets/bike.png";
import styles from "./DuplicateRegistrationCertificate.module.css";
import DuplicateRegisterationForm from "./DuplicateRegisterationForm";
import HireRiderSection from "./HireRiderSection";
import PaymentDetails from "./PaymentDetails";

// Mock news data - all related to Duplicate Registration Certificate
const newsData = [
  {
    id: 1,
    title: "Streamlined Duplicate RC Process",
    subtitle: "New online system cuts duplicate RC issuance time by 50%",
    category: "Process Updates",
    time: "2 hours ago",
    image: "📜",
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    priority: "high"
  },
  {
    id: 2,
    title: "Digital RC Copies Now Accepted",
    subtitle: "Authorities approve digital RC copies for temporary use",
    category: "Policy Updates",
    time: "4 hours ago",
    image: "📱",
    gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    priority: "high"
  },
  {
    id: 3,
    title: "No Police Report Required",
    subtitle: "Simplified procedure for lost RC replacement",
    category: "Documentation",
    time: "1 day ago",
    image: "🗂️",
    gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
    priority: "medium"
  },
  {
    id: 4,
    title: "Reduced Fees for Duplicate RC",
    subtitle: "Government slashes duplicate RC fees by 25%",
    category: "Fee Updates",
    time: "2 days ago",
    image: "💸",
    gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
    priority: "medium"
  },
  {
    id: 5,
    title: "Express Delivery for Duplicate RC",
    subtitle: "Get your duplicate RC delivered in 48 hours",
    category: "Delivery Services",
    time: "3 days ago",
    image: "🚚",
    gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
    priority: "medium"
  },
  {
    id: 6,
    title: "Online Verification Simplified",
    subtitle: "Verify vaahan details online for faster RC replacement",
    category: "Digital Services",
    time: "4 days ago",
    image: "🔍",
    gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
    priority: "low"
  },
  {
    id: 7,
    title: "Extended Validity for Temporary RC",
    subtitle: "Temporary RC now valid for 60 days during replacement",
    category: "Policy Updates",
    time: "5 days ago",
    image: "⏳",
    gradient: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)",
    priority: "medium"
  },
  {
    id: 8,
    title: "Biometric Data Reuse",
    subtitle: "Existing biometrics reused for duplicate RC issuance",
    category: "Process Updates",
    time: "1 week ago",
    image: "👆",
    gradient: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
    priority: "low"
  }
];

function NewsWidget() {
  const [currentNewsIndex, setCurrentNewsIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  // Change news daily based on date
  useEffect(() => {
    const today = new Date();
    const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24);
    setCurrentNewsIndex(dayOfYear % newsData.length);
  }, []);

  // Auto-rotate news every 10 seconds for demo (remove in production)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentNewsIndex((prev) => (prev + 1) % newsData.length);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const currentNews = newsData[currentNewsIndex];

  const handleNewsClick = () => {
    console.log("News clicked:", currentNews);
  };

  return (
    <div className={styles.newsWidget} onClick={handleNewsClick}>
      <div
        className={styles.newsCard}
        style={{ background: currentNews.gradient }}
      >
        <div className={styles.newsHeader}>
          <div className={styles.newsIcon}>
            <FontAwesomeIcon icon={faNewspaper} />
          </div>
          <div className={styles.newsTime}>
            <FontAwesomeIcon icon={faClock} />
            <span>{currentNews.time}</span>
          </div>
        </div>

        <div className={styles.newsContent}>
          <div className={styles.newsEmoji}>{currentNews.image}</div>
          <div className={styles.newsText}>
            <div className={styles.newsCategory}>{currentNews.category}</div>
            <h3 className={styles.newsTitle}>{currentNews.title}</h3>
            <p className={styles.newsSubtitle}>{currentNews.subtitle}</p>
          </div>
        </div>

        <div className={styles.newsFooter}>
          <div className={styles.priorityIndicator}>
            <div className={`${styles.priorityDot} ${styles[currentNews.priority]}`}></div>
            <span className={styles.priorityText}>
              {currentNews.priority.charAt(0).toUpperCase() + currentNews.priority.slice(1)} Priority
            </span>
          </div>
          <FontAwesomeIcon icon={faArrowRight} className={styles.arrowIcon} />
        </div>
      </div>

      <div className={styles.newsIndicators}>
        {newsData.map((_, index) => (
          <div
            key={index}
            className={`${styles.indicator} ${index === currentNewsIndex ? styles.active : ''}`}
          />
        ))}
      </div>
    </div>
  );
}

function DuplicateRegistrationScreen() {
  const [riderDetails, setRiderDetails] = useState({
    address: "",
    landmark: "",
  });

  const handleRiderChange = (e) => {
    setRiderDetails({ ...riderDetails, [e.target.name]: e.target.value });
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.leftContent}>
          <NewsWidget />
          {/* <div className={styles.status}>*E*T**I*G*</div>
          <div className={styles.company}>TVS MOTOS COMPANY LTD, TVS</div>
          <div className={styles.model}>XL100 HEAVY DUTY</div>
          <div className={styles.searchField}>
            <div className={styles.prefix}>
              <img src={indIcon} alt="IND" />
              <span>IND</span>
            </div>
            <input
              type="text"
              defaultValue="MH 15 CV 2211"
              className={styles.input}
            />
            <button className={styles.searchBtn}>
              <FontAwesomeIcon icon={faSearch} className={styles.searchIcon} />
            </button>
          </div>
          <div className={styles.buttonGroup}>
            <button className={styles.actionBtn}>View RC Details</button>
            <button className={styles.actionBtn}>Add To Garage</button>
          </div> */}
        </div>
        <div>
          <img src={bikeImage} alt="Vaahan" className={styles.vehicleImage} />
        </div>
      </div>
      <DuplicateRegisterationForm
        riderDetails={riderDetails}
        onRiderChange={handleRiderChange}
      />
      {/* <HireRiderSection
        riderDetails={riderDetails}
        onRiderChange={handleRiderChange}
      />
      <PaymentDetails /> */}
    </div>
  );
}

export default DuplicateRegistrationScreen;